import { useTranslation } from "react-i18next";

export default function VideoFrames({
  videoFrames,
  deleteFrame,
  handleClickFrame,
  selectedFrame,
}) {
  const { t } = useTranslation();

  if (videoFrames.length < 1) {
    return null;
  }
  return (
    <div className="videoFrames">
      <p>{t("videoFileIndex.frameSection.extractedFrames")}</p>
      <div>
        <div>
          {videoFrames.map((i, idx) => (
            <div key={idx}>
              <div>
                <time>{i.time}</time>
                <button
                  title={t("videoFileIndex.buttons.delete")}
                  onClick={() => deleteFrame(idx)}
                >
                  {t("videoFileIndex.buttons.delete")}
                </button>
              </div>
              <img
                onClick={() => handleClickFrame(idx)}
                src={i.src}
                alt={`capture-${idx}`}
              />
              {i.time === selectedFrame[0]?.time && <mark>1</mark>}
              {i.time === selectedFrame[1]?.time && <mark>2</mark>}
            </div>
          ))}
        </div>
        <div>
          <div>
            <div className="imgDownloadBtnBox">
              <p className="imgTitleP">
                {t("videoFileIndex.frameSection.selectedImage", { index: 1 })}
              </p>
              {selectedFrame[0]?.src && <time>{selectedFrame[0]?.time}</time>}
            </div>
            {selectedFrame[0]?.src ? (
              <img src={selectedFrame[0]?.src} alt="" />
            ) : (
              <strong>1</strong>
            )}
          </div>
          <div>
            <div className="imgDownloadBtnBox">
              <p className="imgTitleP">
                {t("videoFileIndex.frameSection.selectedImage", { index: 2 })}
              </p>
              {selectedFrame[1]?.src && <time>{selectedFrame[1].time}</time>}
            </div>
            {selectedFrame[1]?.src ? (
              <img src={selectedFrame[1]?.src} alt="" />
            ) : (
              <strong>2</strong>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
